module.exports = __webpack_public_path__ + "img/analysis_total.1d0b6112.png";